import React, { useState, useEffect } from 'react';

const RecycleImageSlider = ({ images, onDownloadApp }) => {
    const [currentSlide, setCurrentSlide] = useState(0);

    useEffect(() => {
        if (images.length === 0) return;

        const interval = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % images.length);
        }, 8000); // Auto-slide every 8 seconds

        return () => clearInterval(interval);
    }, [images.length]);

    const translateX = -currentSlide * 100;

    if (images.length === 0) {
        return null;
    }

    return (
        <div className="recycle-slider-section">
            <div className="recycle-slider-container" data-slider-id="recycle-images">
                <div className="recycle-slider-viewport">
                    <div 
                        className="recycle-slider-track" 
                        id="recycle-images-track"
                        style={{
                            transform: `translateX(${translateX}%)`,
                            transition: 'transform 0.5s ease'
                        }}
                    >
                        {images.map((image, index) => (
                            <div key={index} className="recycle-slide">
                                <div className="recycle-image-card">
                                    <div className="recycle-image-placeholder">
                                        <img 
                                            src={image.startsWith('/') ? image : `/${image}`} 
                                            alt={`Recycled Polymer ${index + 1}`}
                                            className="recycle-product-img"
                                            onError={(e) => {
                                                console.error(`Image failed to load: ${image}`);
                                                e.target.style.display = 'none';
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Download App Button */}
                <div className="slider-actions">
                    <button 
                        className="btn btn-download-app" 
                        onClick={onDownloadApp}
                    >
                        <i className="fas fa-mobile-alt"></i>
                        Download App
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RecycleImageSlider;
